import { useCallback, useState } from "react";
import steps from "./steps.config";

/**
 * PD-6 step navigation.
 *
 * Replaces question.js's ad hoc `setComponent("NextName")` chains for the
 * steps built in this milestone. A step component calls `goNext()` once,
 * after its own fields have validated and their individual
 * `partial-application` autosave calls have fired successfully.
 */
export default function useStepNavigation(initialIndex = 0) {
  const [stepIndex, setStepIndex] = useState(initialIndex);

  const goNext = useCallback(() => {
    setStepIndex((current) => Math.min(current + 1, steps.length - 1));
  }, []);

  const goBack = useCallback(() => {
    setStepIndex((current) => Math.max(current - 1, 0));
  }, []);

  const goToStep = useCallback((index) => {
    setStepIndex(Math.max(0, Math.min(index, steps.length - 1)));
  }, []);

  return {
    stepIndex,
    totalSteps: steps.length,
    currentStep: steps[stepIndex],
    isFirstStep: stepIndex === 0,
    isLastStep: stepIndex === steps.length - 1,
    goNext,
    goBack,
    goToStep,
  };
}
